import React, { useEffect, useState } from 'react';
import style from './index.module.scss'
import { getUserInitials } from '../../utils/userDisplay'

export default function Avatar({ user }: any){
    const [hasImageError, setHasImageError] = useState(false)
    const [isImageLoaded, setIsImageLoaded] = useState(false)
    const name = getUserInitials(user)
    const rawAvatarSrc = (
        user?.avatar
        || user?.photo
        || user?.photo_data_url
        || user?.photo_url
        || user?.avatar_url
        || user?.image
        || user?.user?.avatar
        || user?.user?.photo
        || user?.user?.photo_data_url
        || user?.user?.photo_url
        || user?.user?.avatar_url
        || user?.user?.image
    )
    const avatarSrc = hasImageError ? null : rawAvatarSrc

    useEffect(() => {
        setHasImageError(false)
        setIsImageLoaded(false)
    }, [rawAvatarSrc])

    if(avatarSrc){
        return (
            <div className={style.avatar}>
                {!isImageLoaded && name}
                <img
                    src={avatarSrc}
                    alt=""
                    draggable={false}
                    style={{ opacity: isImageLoaded ? 1 : 0 }}
                    onLoad={() => setIsImageLoaded(true)}
                    onError={() => setHasImageError(true)}
                />
            </div>
        )
    }

    if(name){
        return (
            <div className={style.avatar}>
                {name}
            </div>
        )
    }


    return  (
        <div className={style.avatar}>
            <img src={'/items/user.svg'} alt="user" draggable={false} />
        </div>
    )
}
